import React from 'react';

// import Footer from "../FooterAndLinks/Footer";
import "../Player.css";
import FeedbackCarouselBody from "./FeedbackCarouselBody";

function Player({ spotify }) {
  return (
    <div className="player">
      <div className="player__body">
          {/* FooterAutoplay moved to App.js level to persist across navigation */}
        <FeedbackCarouselBody spotify={spotify} />
      
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default Player;
